"use client";

import { MessagesList } from "./MessagesList";
import { NewMessageForm } from "./NewMessageForm";

/**
 * Plugin view dispatcher dla `c_private_messages`. Mapuje `actionId` (po prefix
 * `extension-`) na konkretny renderer.
 *
 * Aktualnie wspierane akcje (MVP iter 2):
 *   - `received-messages` -> `<MessagesList folder="inbox" />` (lista odebranych)
 *   - `sent-messages` -> `<MessagesList folder="sent" />` (lista wysłanych)
 *   - `new-message` -> `<NewMessageForm />` (formularz nowej wiadomości)
 *   - `preview-message-{id}` -> TODO (kolejna iteracja)
 *
 * Nieobsługiwane akcje zwracają null — caller (ExtensionActionView) renderuje
 * fallback placeholder z dev info.
 */
export function CPrivateMessagesView({ actionId }: { actionId: string }) {
  if (actionId === "received-messages") {
    return <MessagesList folder="inbox" />;
  }
  if (actionId === "sent-messages") {
    return <MessagesList folder="sent" />;
  }
  if (actionId === "new-message") {
    return <NewMessageForm />;
  }
  /* `preview-message-{id}` — przyszłe iteracje. */
  return null;
}

/**
 * Helper — czy CPrivateMessagesView obsługuje konkretną akcję.
 * Używane w ExtensionActionView do decyzji "render plugin view vs fallback".
 */
export function cPrivateMessagesHandlesAction(actionId: string): boolean {
  return (
    actionId === "received-messages"
    || actionId === "sent-messages"
    || actionId === "new-message"
  );
}
